// extracted by mini-css-extract-plugin
export default {"journalIcon":"utils_journalIcon__vSIBO"};